import { useEffect } from 'react';

import { useMapViewSelector } from '@src/contexts';

import { useMapStyle } from './useMapStyle';

export function useActiveMapStyle() {
  const mapInstance = useMapViewSelector(store => store.mapInstance);

  const { currentMapStyle } = useMapStyle();

  useEffect(() => {
    if (!mapInstance) return;
    mapInstance.updateMapStyle(currentMapStyle.value);
  }, [currentMapStyle.value, mapInstance]);

  return null;
}
